// Componente basado en EstablecimientoEdit, pero como vista solo lectura
import React, { useState, useContext, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid2";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Download as DownloadIcon } from "@mui/icons-material";
import PageButtonSimple from "../GeneralComponents/PageButtonSimple";
import PageButtonBlack from "../GeneralComponents/PageButtonBlack";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import ModalStandard from "../GeneralComponents/ModalStandard";
import Alert from "@mui/material/Alert";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import axios from "../../api/axios";
import GeneralContext from "../GeneralContext/GeneralContext";
import PageBody from "../GeneralComponents/PageBody";
import PageBgBlock from "../GeneralComponents/PageBgBlock";
import HourglassLoader from "../GeneralComponents/HourglassLoader";
import PageError from "../GeneralComponents/PageError";
import InputAddress from "../GeneralComponents/InputAddress";
import PanelAdminRepresentantes from "../GeneralComponents/PanelAdminRepresentantes";

import { sxEstilos, borderStyle, tbPad } from "../../Constants/Constants";

import {ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN} from "../../Constants/Constants";

const jornadas = {
  a: "8:00 a 19:45 (A)",
  b: "8:00 a 15:45 (B)",
  c: "8:00 a 17:45 (C)",
  d: "8:00 a 23:15 (D)",
  e: "Ninguno (E)",
};

const TIPO_ESTABLECIMIENTO_OPTIONS = [
  { value: "ADMINISTRACION DELEGADA", label: "ADMINISTRACIÓN DELEGADA" },
  { value: "MUNICIPAL DAEM", label: "MUNICIPAL DAEM" },
  { value: "PARTICULAR SUBVENCIONADO", label: "PARTICULAR SUBVENCIONADO" },
  { value: "SERVICIO LOCAL DE EDUCACIÓN (SLE)", label: "SERVICIO LOCAL DE EDUCACIÓN (SLE)" },
  { value: "SERVICIO LOCAL DE EDUCACIÓN PÚBLICA (SLEP)", label: "SERVICIO LOCAL DE EDUCACIÓN PÚBLICA (SLEP)" },
];








export default function EstablecimientoView() {
  const { setDrawerHidding, userSesion, includeRol } = useContext(GeneralContext);
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [documentVisible, setDocumentVisible] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [formData, setFormData] = useState({
    rbd: "",
    nombre: "",
    id_zona: "",
    fecha_creacion: "",
    email: "",
    latitud: "",
    longitud: "",
    tipo_establecimiento: "",
    telefono: "",
    direccion: "",
    direccion2: "",
    descripcion: "",
    jornada_a: false,
    jornada_b: false,
    jornada_c: false,
    jornada_d: false,
    jornada_e: false,
    option: null,
  });

  const [loadingPDF, setLoadingPDF] = useState(false);
  const [infoAltaBaja, setInfoAltaBaja] = useState({
    fecha_alta: null,
    fecha_alta_devengo: null,
    fecha_baja: null,
    fecha_baja_devengo: null,
    oficio_baja_url: null,
    oficio_inicio_servicio_url: null,
    oficio_recepcion_de_obra_url: null,
  });
  const handleClose = () => setOpen(false);
  const navigate = useNavigate();
  const [listaRep, setListaRep] = useState([]);
  const [submitConfirm, setSubmitConfirm] = useState(false);
  const [modalError, setModalError] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [error, setError] = useState("");
  const [open, setOpen] = React.useState(false);

  const [editable, setEditable] = React.useState(includeRol([ROL_ADMIN, ROL_CON_MINEDUC, ROL_MINEDUC_ADMIN]))

  const [currentRbd, setCurrentRbd] = useState(0);
  const formRef = useRef();

  const fetchData = async () => {
    const rbdSolicitado = id;
    getEes(rbdSolicitado);
    setDocumentVisible(true);
  };

  const downloadPDF = (url, rbd) => {
    setLoadingPDF(true);
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/pdf",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.blob();
      })
      .then((blob) => {
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        a.href = blobUrl;
        a.download = rbd + ".pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
        setLoadingPDF(false);
      })
      .catch((error) => {
        setLoadingPDF(false);
        console.error("Error al descargar el archivo:", error);
        window.open(url, "_blank");
      });
  };

  const getPanelRepData = () => {
    const datos = formRef.current?.datos;
  };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };
  const handleSelectChange = (event) => {
  const { name, value } = event.target;
  setFormData((prev) => ({ ...prev, [name]: value }));
};

const handleJornadaChange = (j) => (event) => {
  const checked = event.target.checked;
  setFormData((prev) => {
    const next = { ...prev };

    if (j === "e") {
      next.jornada_e = checked;
      if (checked) {
        next.jornada_a = false;
        next.jornada_b = false;
        next.jornada_c = false;
        next.jornada_d = false;
      }
    } else {
      next[`jornada_${j}`] = checked;
      if (checked) next.jornada_e = false;
    }

    return next;
  });
};

  async function handleClick(event) {
    event.preventDefault();
    setLoadingButton(true);
    getPanelRepData();

    if (!formRef.current?.esValido()) {
      setLoadingButton(false);
      return;
    }
    if (!submitConfirm) {
      setSubmitConfirm(true);
      setLoadingButton(false);
      return;
    }

    try {
      const fallidos = await formRef.current.enviarFormulario(currentRbd);
      const response = await axios.putEesInfo(formData.rbd, formData);
      if (fallidos.length) {
        setModalError(true);
        const ruts = fallidos.map((r) => r.rut).join(", ");
        setModalContent(
          `No se pudo ingresar datos de algunos usuarios (${ruts})`
        );
      } else {
        setModalContent(`Datos actualizados`);
        setModalError(false);
      }
      setOpen(true);
    } catch (error) {
      setModalError(true);
    } finally {
      setLoading(false);
      setLoadingButton(false);
      setSubmitConfirm(false);
      fetchData();
    }
  }

  const getEes = (rbd_temp) => {
    axios
      .getEesInfo(rbd_temp)
      .then((response) => {
        const updatedData = Object.fromEntries(
          Object.entries(response.data).filter(([key]) => key !== "rbd")
        );
        setFormData((prevFormData) => ({
          ...prevFormData,
          ...updatedData,
          rbd: rbd_temp,
        }));
        getEes2(rbd_temp);
        getAltaBaja(rbd_temp);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const getEes2 = (rbd_temp) => {
    axios
      .getRepresentantes(rbd_temp)
      .then((response) => {
        const conRbd = response.data.nombres_representantes.map((item) => ({
          ...item,
          rbd: rbd_temp,
        }));
        if (formRef.current?.setDatosExternos) {
          formRef.current.setDatosExternos(conRbd);
        }
        setListaRep(conRbd);
      })
      .catch(() => {});
  };

  const getAltaBaja = (rbd_temp) => {
    axios
      .getAltaBajaInfoRBD(rbd_temp)

      .then((response) => {
        const data = response.data;
        setInfoAltaBaja((prevFormData) => ({
          ...prevFormData,
          ...data,
          fecha_alta: data.fecha_alta ? data.fecha_alta.split("T")[0] : null,
          fecha_alta_devengo: data.fecha_alta_devengo
            ? data.fecha_alta_devengo.split("T")[0]
            : null,
          fecha_baja: data.fecha_baja ? data.fecha_baja.split("T")[0] : null,
          fecha_baja_devengo: data.fecha_baja_devengo
            ? data.fecha_baja_devengo.split("T")[0]
            : null,
        }));
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchData();
    setDrawerHidding(false);
  }, []);

  return (
    <PageBody>
      {loading ? (
        <PageBgBlock pad="0">
          <HourglassLoader />
        </PageBgBlock>
      ) : documentVisible ? (
      <>
        <PageBgBlock pad="0">
          <Box
            sx={{ paddingLeft: "9rem", paddingRight: "9rem", paddingY: "2rem" }}
          >
            <Stack sx={{ background: "#FFFFFF", borderRadius: "0.5rem" }}>
              <Box>
                <Stack alignItems="left" justifyContent="center" spacing={2}>
                  <Typography
                    variant="h1"
                    sx={{ textAlign: "center", fontWeight: 700 }}
                  >
                    VER ESTABLECIMIENTO
                  </Typography>

                  <Grid container spacing={2}>
                    <Grid size={6}>
                      <FormControl fullWidth>
                        <TextField
                          label="RBD"
                          name="rbd"
                          size="small"
                          value={formData.rbd}
                          disabled
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={6}>
                      <FormControl fullWidth>
                        <TextField
                          label="Nombre"
                          name="nombre"
                          size="small"
                          disabled={!editable}
                          value={formData.nombre}
                          onChange={handleInputChange}
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={12}>
                      <FormControl fullWidth>
                        <TextField
                          label="direccion"
                          name="nombre"
                          size="small"
                          value={formData.direccion}
                          disabled
                        />
                      </FormControl>
                    </Grid>
                    <Grid size={4}>
                      <TextField
                        label="Latitud"
                        name="nombre"
                        size="small"
                        value={formData.latitud}
                        disabled
                        fullWidth
                      />
                    </Grid>
                    <Grid size={4}>
                      <TextField
                        label="Longitud"
                        name="nombre"
                        size="small"
                        value={formData.longitud}
                        disabled
                        fullWidth
                      />
                    </Grid>
                    <Grid size={4}>
                      <TextField
                        label="ID Zona"
                          name="id_zona"
                        size="small"
                        value={formData.id_zona}
                        disabled
                        fullWidth
                      />
                    </Grid>
                    <Grid size={6}>
                      <TextField
                        label="Teléfono"
                          name="telefono"
                        size="small"
                        disabled={!editable}
                        value={formData.telefono}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid size={6}>
                      <TextField
                        label="Email"
                          name="email"
                          disabled={!editable}
                        size="small"
                        value={formData.email}
                        onChange={handleInputChange}
                        fullWidth
                      />
                    </Grid>
                    <Grid size={6}>
                      <TextField
    select
    label="Tipo de establecimiento"
    name="tipo_establecimiento"
    size="small"
    disabled={!editable}
    value={formData.tipo_establecimiento ?? ""} 
    onChange={handleSelectChange}
    fullWidth
  >
    {TIPO_ESTABLECIMIENTO_OPTIONS.map((opt) => (
      <MenuItem key={opt.value} value={opt.value}>
        {opt.label}
      </MenuItem>
    ))}
  </TextField>
                    </Grid>
                    <Grid size={6}>
                      <TextField
                        label="Fecha de ingreso"
                        size="small"
                        value={formData.fecha_creacion}
                        disabled
                        fullWidth
                      />
                    </Grid>

                    <Grid size={4}>
                      <Typography variant="body">Tipo de jornada:</Typography>
                    </Grid>

                    <Grid size={8}>
                      <Grid container spacing={2} columns={6}>
                        {["a", "b", "c", "d", "e"].map((j) => (
      <Grid size={2} key={j}>
        <FormControlLabel
          control={
            <Checkbox
              disabled={!editable}
              checked={Boolean(formData[`jornada_${j}`])}
              onChange={handleJornadaChange(j)}
            />
          }
          label={jornadas[j]}
        />
      </Grid>
    ))}
                      </Grid>
                      
                    </Grid>








                    <Grid size={12}>
                      <form onSubmit={handleClick} id="parque_update">
                        <PanelAdminRepresentantes
                          ref={formRef}
                          lista_rep={listaRep}
                          rutUsuario={userSesion.rut}
                          soloLectura={false}
                          mineduc={true}
                        />
                      </form>
                    </Grid>

                     {submitConfirm ? (
                          <Grid
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            size={12}
                            sx={{ paddingY: "0" }}
                          >
                            <Alert
                              icon={false}
                              variant="filled"
                              severity="warning"
                              sx={{
                                display: "flex",
                                justifyContent: "center",
                                "& .MuiAlert-message": {
                                  textAlign: "center",
                                  width: "inherit",
                                },
                              }}
                            >
                              <Typography
                                variant="body"
                                color="inherit"
                                sx={{ textAlign: "center" }}
                              >
                                Atención: Revise con atención los datos proporcionados en la modificación para evitar procesos erroneos. Al presionar ‘Modificar establecimiento’ se hará el cambio en nustras bases de datos, si no está seguro salga de la edición sin modificar.
                              </Typography>
                            </Alert>
                          </Grid>
                        ) : (
                          ""
                        )}
                      {editable &&
                    <Grid size={12}>
                      <Box mt={2} display="flex" justifyContent="center">
                        <PageButtonBlack
                          width="20rem"
                          disabled={loadingButton}
                          form="parque_update"
                          startIcon={<AddCircleOutlineIcon />}
                          sx={{ borderRadius: 0 }}
                          loading={loading}
                        >
                          Guardar actualización
                        </PageButtonBlack>
                      </Box>
                    </Grid>}

                  </Grid>
                </Stack>
              </Box>
            </Stack>
          </Box>


        </PageBgBlock>
        <Box sx={{width: "100%", mt:2}}></Box>
        <PageBgBlock>

                    <Grid size={12}>
                      <Grid size={12}>
                        <Typography
                          variant="h6"
                          sx={{
                            textAlign: "center",
                            fontWeight: 700,
                            pb: 2,
                            pt: 1,
                          }}
                        >
                          FECHA DE ALTA Y BAJA DEL SERVICIO
                        </Typography>
                      </Grid>

                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                ...sxEstilos.tdNormalBold,
                                ...sxEstilos.rowGray,
                                width: "33%",
                              }}
                            >
                              Recepción de obras <br /> (Alta)
                            </TableCell>
                            <TableCell
                              sx={{
                                ...sxEstilos.tdNormalBold,
                                ...sxEstilos.rowGray,
                                width: "33%",
                              }}
                              align="right"
                            >
                              Inicio de servicios <br /> (Alta)
                            </TableCell>
                            <TableCell
                              sx={{
                                ...sxEstilos.tdNormalBold,
                                ...sxEstilos.rowGray,
                              }}
                              align="right"
                            >
                              Baja
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow>
                            <TableCell sx={{ ...sxEstilos.tdNormal }}>
                              <PageButtonSimple
                                disabled={
                                  !infoAltaBaja.oficio_recepcion_de_obra_url
                                }
                                width="100%"
                                pad="0.2rem 0.5rem"
                                startIcon={
                                  infoAltaBaja.fecha_alta_devengo ? (
                                    <DownloadIcon />
                                  ) : null
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  downloadPDF(
                                    infoAltaBaja.oficio_recepcion_de_obra_url,
                                    id
                                  );
                                }}
                              >
                                {infoAltaBaja.fecha_alta_devengo
                                  ? infoAltaBaja.fecha_alta_devengo
                                  : "-"}
                              </PageButtonSimple>
                            </TableCell>
                            <TableCell
                              sx={{ ...sxEstilos.tdNormal }}
                              align="right"
                            >
                              <PageButtonSimple
                                disabled={
                                  !infoAltaBaja.oficio_inicio_servicio_url
                                }
                                width="100%"
                                pad="0.2rem 0.5rem"
                                startIcon={
                                  infoAltaBaja.fecha_alta ? (
                                    <DownloadIcon />
                                  ) : null
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  downloadPDF(
                                    infoAltaBaja.oficio_inicio_servicio_url,
                                    id
                                  );
                                }}
                              >
                                {infoAltaBaja.fecha_alta
                                  ? infoAltaBaja.fecha_alta
                                  : "-"}
                              </PageButtonSimple>
                            </TableCell>
                            <TableCell
                              sx={{ ...sxEstilos.tdNormal }}
                              align="right"
                            >
                              <PageButtonSimple
                                disabled={!infoAltaBaja.oficio_baja_url}
                                pad="0.2rem 0.5rem"
                                width="100%"
                                startIcon={
                                  infoAltaBaja.fecha_baja ? (
                                    <DownloadIcon />
                                  ) : null
                                }
                                onClick={(e) => {
                                  e.stopPropagation();
                                  downloadPDF(infoAltaBaja.oficio_baja_url, id);
                                }}
                              >
                                {infoAltaBaja.fecha_baja
                                  ? infoAltaBaja.fecha_baja
                                  : "-"}
                              </PageButtonSimple>
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </Grid>
        </PageBgBlock>
        </>
      ) : (
        <PageError>No tiene acceso a esta RBD.</PageError>
      )}

      <ModalStandard
        open={open}
        error={modalError}
        title={modalContent}
        btnText="Volver a listado parque"
        onClick={() => navigate("/parque_lista")}
        onClose={handleClose}
      ></ModalStandard>
    </PageBody>
  );
}
